import { Helmet } from 'react-helmet-async';
import PrivacyPolicyView from 'src/sections/privacy-policy/view/privacy-policy-view';


export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy </title>
      </Helmet>
      <PrivacyPolicyView />
    </>
  )
}
